<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M2.75469 14.7154L3.27239 16.6473C3.87659 18.9024 4.17878 20.0299 4.86368 20.7612C5.40448 21.3386 6.10439 21.7427 6.87479 21.9223C6.97109 21.9448 7.06878 21.9621 7.16898 21.9744C8.08408 22.0873 9.20059 21.7881 11.2332 21.2435C13.4883 20.6392 14.6158 20.3371 15.3471 19.6522C15.9245 19.1114 16.3286 18.4115 16.5083 17.641C16.7358 16.6652 16.4337 15.5377 15.8294 13.2826L15.3118 11.3508C15.2249 11.0265 15.1442 10.7254 15.0678 10.4456C14.6127 8.77957 14.3069 7.86298 13.7205 7.23687C13.1797 6.65945 12.4798 6.25537 11.7093 6.07573C10.7336 5.84821 9.60598 6.15033 7.35088 6.75458C5.09588 7.35883 3.96829 7.66095 3.23699 8.34587C2.65958 8.88668 2.25548 9.58657 2.07588 10.357C1.84838 11.3328 2.15049 12.4603 2.75469 14.7154Z"
      fill="black"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M2.75469 14.7154L3.27239 16.6473C3.87659 18.9024 4.17878 20.0299 4.86368 20.7612C5.40448 21.3386 6.10439 21.7427 6.87479 21.9223C6.97109 21.9448 7.06878 21.9621 7.16898 21.9744C8.08408 22.0873 9.20059 21.7881 11.2332 21.2435C13.4883 20.6392 14.6158 20.3371 15.3471 19.6522C15.9245 19.1114 16.3286 18.4115 16.5083 17.641C16.7358 16.6652 16.4337 15.5377 15.8294 13.2826L15.3118 11.3508C15.2249 11.0265 15.1442 10.7254 15.0678 10.4456C14.6127 8.77957 14.3069 7.86298 13.7205 7.23687C13.1797 6.65945 12.4798 6.25537 11.7093 6.07573C10.7336 5.84821 9.60598 6.15033 7.35088 6.75458C5.09588 7.35883 3.96829 7.66095 3.23699 8.34587C2.65958 8.88668 2.25548 9.58657 2.07588 10.357C1.84838 11.3328 2.15049 12.4603 2.75469 14.7154Z"
      :fill="`url(#${componentId}_paint0_linear_4224_1707)`"
    />
    <foreignObject
      x="6"
      y="1"
      width="16.584"
      height="17.998"
    ><div
      xmlns="http://www.w3.org/1999/xhtml"
      :style="`backdrop-filter: blur(0.5px); clip-path: url(#${componentId}_bgblur_0_4224_1707_clip_path); height: 100%; width: 100%`"
    /></foreignObject>
    <g :filter="`url(#${componentId}_filter0_i_4224_1707)`" data-figma-bg-blur-radius="1">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M20.8293 10.7154L20.3116 12.6473C19.7074 14.9024 19.4052 16.0299 18.7203 16.7612C18.1795 17.3386 17.4796 17.7427 16.7092 17.9223C16.6129 17.9448 16.5152 17.9621 16.415 17.9744C15.4999 18.0873 14.3834 17.7881 12.3508 17.2435C10.0957 16.6392 8.96815 16.3371 8.23687 15.6522C7.65945 15.1114 7.25537 14.4115 7.07573 13.641C6.84821 12.6652 7.15033 11.5377 7.75458 9.28263L8.27222 7.35077C8.3591 7.02654 8.43979 6.7254 8.51621 6.44561C8.97128 4.77957 9.27709 3.86298 9.86351 3.23687C10.4043 2.65945 11.1042 2.25537 11.8747 2.07573C12.8504 1.84821 13.978 2.15033 16.2331 2.75458C18.4881 3.35883 19.6157 3.66095 20.347 4.34587C20.9244 4.88668 21.3285 5.58657 21.5081 6.35703C21.7356 7.3328 21.4335 8.46034 20.8293 10.7154ZM11.0524 9.80589C11.1596 9.40579 11.5709 9.16835 11.971 9.27556L16.8006 10.5697C17.2007 10.6769 17.4381 11.0881 17.3309 11.4882C17.2237 11.8883 16.8125 12.1257 16.4124 12.0185L11.5827 10.7244C11.1826 10.6172 10.9452 10.206 11.0524 9.80589ZM10.2756 12.7033C10.3828 12.3032 10.794 12.0658 11.1941 12.173L14.0919 12.9495C14.492 13.0567 14.7294 13.4679 14.6222 13.868C14.515 14.2681 14.1038 14.5056 13.7037 14.3984L10.8059 13.6219C10.4058 13.5147 10.1683 13.1034 10.2756 12.7033Z"
        fill="#3AFCC9"
        fill-opacity="0.6"
      />
    </g>
    <defs>
      <filter
        :id="`${componentId}_filter0_i_4224_1707`"
        x="6"
        y="1"
        width="16.584"
        height="17.998"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
        <feOffset dx="0.25" dy="0.25" />
        <feGaussianBlur stdDeviation="0.25" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
        <feBlend mode="normal" in2="shape" result="effect1_innerShadow_4224_1707" />
      </filter>
      <clipPath :id="`${componentId}_bgblur_0_4224_1707_clip_path`" transform="translate(-6 -1)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M20.8293 10.7154L20.3116 12.6473C19.7074 14.9024 19.4052 16.0299 18.7203 16.7612C18.1795 17.3386 17.4796 17.7427 16.7092 17.9223C16.6129 17.9448 16.5152 17.9621 16.415 17.9744C15.4999 18.0873 14.3834 17.7881 12.3508 17.2435C10.0957 16.6392 8.96815 16.3371 8.23687 15.6522C7.65945 15.1114 7.25537 14.4115 7.07573 13.641C6.84821 12.6652 7.15033 11.5377 7.75458 9.28263L8.27222 7.35077C8.3591 7.02654 8.43979 6.7254 8.51621 6.44561C8.97128 4.77957 9.27709 3.86298 9.86351 3.23687C10.4043 2.65945 11.1042 2.25537 11.8747 2.07573C12.8504 1.84821 13.978 2.15033 16.2331 2.75458C18.4881 3.35883 19.6157 3.66095 20.347 4.34587C20.9244 4.88668 21.3285 5.58657 21.5081 6.35703C21.7356 7.3328 21.4335 8.46034 20.8293 10.7154ZM11.0524 9.80589C11.1596 9.40579 11.5709 9.16835 11.971 9.27556L16.8006 10.5697C17.2007 10.6769 17.4381 11.0881 17.3309 11.4882C17.2237 11.8883 16.8125 12.1257 16.4124 12.0185L11.5827 10.7244C11.1826 10.6172 10.9452 10.206 11.0524 9.80589ZM10.2756 12.7033C10.3828 12.3032 10.794 12.0658 11.1941 12.173L14.0919 12.9495C14.492 13.0567 14.7294 13.4679 14.6222 13.868C14.515 14.2681 14.1038 14.5056 13.7037 14.3984L10.8059 13.6219C10.4058 13.5147 10.1683 13.1034 10.2756 12.7033Z"
        />
      </clipPath>
      <linearGradient
        :id="`${componentId}_paint0_linear_4224_1707`"
        x1="-12.9888"
        y1="2.88927"
        x2="8.22917"
        y2="30.5597"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#CBFFF1" />
        <stop offset="0.551244" stop-color="#1DFFC3" />
        <stop offset="1" stop-color="#0A4C3B" />
      </linearGradient>
    </defs>
  </svg>
</template>

<script>
export default {
  props: {
    componentId: {
      type: String,
      default: ''
    }
  }
}
</script>
